import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import GenericListPair from 'modules/common/components/GenericListPair';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import useDebounce from 'modules/common/hooks/useDebounce';
import * as actions from '../action';
import * as c from '../constant';
import FaqsMainContent from './FaqsMainContent';
import CreateModal from '../components/CreateModal';
import UpdateModal from '../components/UpdateModal';

const INIT_FILTER = {
  sort_by: 'desc',
  q: '',
};

function FaqsMainContainer({
  match,
  history,
  getFaqList,
  faqList,
  faqListPager,
  isLoading,
  removeFaq,
}) {
  const [filter, setFilter] = useState(INIT_FILTER);
  const debouncedFilter = useDebounce(filter, 500);
  const setModal = useContext(ModalContext);

  useEffect(() => {
    getFaqList(debouncedFilter);

    return () => {
      setModal({ isOpen: false });
    };
  }, [JSON.stringify(debouncedFilter)]);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setFilter((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal />,
      title: 'Add Frequently Asked Questions',
      modalSize: 'modal-xl',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data.attributes} id={data.id} />,
      title: 'Update Frequently Asked Questions',
      modalSize: 'modal-xl',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this frequently asked question?',
      () => {
        removeFaq(data.id, () => {
          getFaqList(INIT_FILTER);
          const id = _.get(faqList, '0.id');
          history.push(`/general-settings/faq/main/${id}`);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:faqId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Menu List"
            // getData={getFaqList}
            // setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(filter, 'q') || ''}
            keywordPlaceholder="Search menu..."
            listName="Title List"
            label="FAQ's List"
            renderItem={(item) => (
              <div className="px-3 py-3">
                {_.get(item, 'attributes.title_en')}
              </div>
            )}
            isLoading={isLoading}
            selected={params.faqId}
            data={faqList}
            dataPager={faqListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:faqId?`}
                    render={() => (
                      <FaqsMainContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:faqId?`}
                  render={() =>
                    !params.faqId && faqList.length > 0 ? (
                      <Redirect to={`${match.url}/${_.get(faqList, '0.id')}`} />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
            handleChangePage={(page) =>
              setFilter((prev) => ({ ...prev, page }))
            }
          />
        )}
      />
    </div>
  );
}

FaqsMainContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getFaqList: PropTypes.instanceOf(Function).isRequired,
  faqList: PropTypes.instanceOf(Array).isRequired,
  faqListPager: PropTypes.instanceOf(Object).isRequired,
  removeFaq: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  faqList: _.get(api, `${c.GET_FAQ_LIST}.list`) || [],
  faqListPager: _.get(api, `${c.GET_FAQ_LIST}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_FAQ_LIST) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(FaqsMainContainer);
